module.exports = __webpack_public_path__ + "img/logo-200x200.57ab1a12.png";